// @flow
import { useState, useCallback } from 'react';

import { api } from 'app/api';
import { POST_CAFETERIA_CUSTOMER_ORDERS_SALES, convertParams } from 'app/common/api/requests/cafeteria/customer/orders/sales.post';
import type { OrderItemMap } from 'app/common/components/Cafeteria/dataTypes/order/OrderItem.types';
import usePopup from 'app/common/hooks/usePopup';


type Options = {
  orderId: string,
  changeId: string,
  customerId: string,
  orderItemsMap: OrderItemMap,
  onSuccess?: () => Promise<void> | void,
  onFailure?: () => Promise<void> | void,
  successMessage: string,
  errorProcessing: (error: Error) => string,
}

export default function useOrderSalesSubmit(options: Options): [() => Promise<void>, boolean] {
  const {
    orderId,
    changeId,
    customerId,
    orderItemsMap,
    onSuccess,
    onFailure,
    successMessage,
    errorProcessing,
  } = options;

  const [submitting, setSubmitting] = useState(false);

  const popup = usePopup();

  const submit = useCallback(async () => {
    setSubmitting(true);
    const res = await api.request(POST_CAFETERIA_CUSTOMER_ORDERS_SALES, {
      error: error => errorProcessing(error),
      params: {
        orderId,
        changeId,
        customerId,
        orderItemsMap,
      },
      convertions: {
        convertParams,
      },
    });

    if (res) {
      if (onSuccess) onSuccess();
      popup(successMessage);
      return;
    }
    setSubmitting(false);
    if (onFailure) onFailure();
  }, [
    orderId,
    changeId,
    customerId,
    orderItemsMap,
    onSuccess,
    onFailure,
    errorProcessing,
    successMessage,
    popup,
  ]);

  return [submit, submitting];
}
